// D:\live event\hrexora-frontend-main\src\components\Login.js

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";
import { backend_url } from "../constants/backend";

function Login() {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");

  const navigate = useNavigate();

  // Auto-hide messages after 5 seconds
  useEffect(() => {
    if (message) {
      const t = setTimeout(() => setMessage(""), 5000);
      return () => clearTimeout(t);
    }
  }, [message]);

  // 🔐 Handle login
  const handleSubmit = async (e) => {
    e.preventDefault();

    const trimmedEmail = identifier.trim();
    const trimmedPassword = password.trim();

    if (!trimmedEmail) {
      setMessage("Please enter your email.");
      return;
    }

    if (!trimmedPassword) {
      setMessage("Please enter your password.");
      return;
    }

    setSubmitting(true);
    setMessage("");

    try {
      const resp = await fetch(`${backend_url}/login/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          identifier: trimmedEmail,
          password: trimmedPassword,
        }),
      });

      if (!resp.ok) {
        const data = await resp.json().catch(() => ({}));
        setMessage(data?.detail || "Invalid email or password");
        setSubmitting(false);
        return;
      }

      const data = await resp.json();

      sessionStorage.setItem("userEmail", trimmedEmail);
      if (data?.role) {
        sessionStorage.setItem("userRole", data.role);
      }

      window.dispatchEvent(new Event("userEmailChanged"));
      window.dispatchEvent(new Event("userRoleChanged"));

      navigate("/profile", { state: { email: trimmedEmail } });
    } catch (err) {
      console.error(err);
      setMessage("Something went wrong. Please try again.");
    }

    setSubmitting(false);
  };

  return (
    <div className="login-page react-background">
      <div className="login-wrapper" style={{ marginTop: "120px" }}>
        <div className="login-header">
          <h2 className="login-title">Login</h2>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-grid-login">
            <div className="form-row email-row">
              <label>Email</label>
              <input
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                placeholder="Enter email"
              />
            </div>

            <div className="form-row">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
              />
            </div>
          </div>

          {message && <div className="message">{message}</div>}

          <div className="form-actions">
            <button className="btn submit-btn" disabled={submitting}>
              {submitting ? "Submitting..." : "Login"}
            </button>
          </div>

          <div className="register-section">
            <p>
              Don't have an account?
              <span
                className="register-link"
                onClick={() => navigate("/welcome")}
              >
                Register
              </span>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
